import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../Redux/Layout/layoutSlice";

const Overlay = ({ direction = "rtl" }) => {
  // @ts-ignore
  const { sidebarIsOpen } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  // Adjust overlay position for RTL/LTR
  const positionClass = direction === "rtl" ? "left-0" : "right-0";

  return (
    <Box
      className={`
        md:hidden
        fixed top-0 ${positionClass} w-full h-full bg-[#00000066] transition-all duration-[400ms]
        opacity-0 invisible
        ${sidebarIsOpen && "!opacity-100 !visible"}
      `}
      sx={{ zIndex: 3 }}
      onClick={() => dispatch(toggleSidebar())}
    ></Box>
  );
};

export default Overlay;